<template>
    <div>
        <div class="tabs">
            <ul>
                <li
                    v-for="(tab, index) in tabs"
                    :key="index"
                    :class="{ 'is-active': activeTab === tab }"
                    @click="selectTab(tab, index)"
                >
                    <div>
                        <slot :name="tabHeadSlotName(tab)">
                            {{ tab }}
                        </slot>
                    </div>
                </li>
            </ul>
        </div>
        <div
            class="tabs-details"
            :class="{ 'border-radius-left': tabIndex === 0, 'border-radius-right': tabIndex === tabs.length - 1 }"
        >
            <slot :name="tabBodySlotName" />
        </div>
    </div>
</template>

<script>
export default {
    props: {
        tabs: Array,
        initialTab: {
            type: Number,
            default: 0,
        },
    },
    data() {
        return {
            activeTab: this.initialTab,
            selectedTabIndex: 0,
        };
    },
    computed: {
        tabBodySlotName() {
            return `tab-body-${this.activeTab}`;
        },
        tabIndex() {
            return this.selectedTabIndex;
        },
    },
    methods: {
        tabHeadSlotName(tabName) {
            return `tab-head-${tabName}`;
        },
        selectTab(tabName, tabIndex) {
            this.selectedTabIndex = tabIndex;
            this.activeTab = tabName;
            this.$emit('tab-changed', this.selectedTabIndex);
        },
    },
};
</script>

<style lang="scss" scoped>
.tabs {
    ul {
        list-style: none;
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin-bottom: 0;
        padding-left: 0;
        li {
            border-top-left-radius: 6px;
            border-top-right-radius: 6px;
            border: 1px solid $color-grey-3;
            border-bottom: 0;
            text-align: center;
            font-weight: bold;
            //this width should be changed if we want to support more then 2 tabs
            width: 49.5%;
            height: 3.25rem;
            background: $color-primary;
            &.is-active {
                color: $color-primary;
                &:hover {
                    color: $color-primary;
                }
            }
            &:not(.is-active):hover {
                color: $color-button;
            }
            div {
                width: 100%;
                height: 100%;
                display: flex;
                align-items: center;
                justify-content: center;
                color: $color-button-text;

                &:hover {
                    cursor: pointer;
                    text-decoration: underline;
                }
            }
            position: relative;
            &:not(.is-active) {
                &:after {
                    pointer-events: none;
                    position: absolute;
                    z-index: 1;
                    bottom: 0;
                    left: 0;
                    right: 0;
                    width: 100%;
                    height: 20%;
                    background: linear-gradient(transparent, rgba($color-grey-9, 0.25));
                    content: '';
                }
                &:before {
                    pointer-events: none;
                    content: '';
                    position: absolute;
                    bottom: -1rem;
                    left: 0;
                    right: 0;
                    //this color is not in the variables
                    background: #0160a1;
                    height: 1rem;
                }
            }

            &.is-active {
                z-index: 1;
                background: $color-button;

                div {
                    color: $color-primary;
                }
            }
        }
    }
}
.tabs-details {
    position: relative;
    background: white;
    top: -1px;
    border: 1px solid $color-grey-3;
    padding: 1rem;
    border-radius: $border-radius-default;
    @media screen and (min-width: 768px) {
        padding: 2rem;
    }
    &.border-radius-right {
        border-top-right-radius: 0;
    }
    &.border-radius-left {
        border-top-left-radius: 0;
    }
}
</style>
